<template>
  <div class="holiday-hours">
    <div class="holiday-hours__holiday" v-for="(holiday, index) of holidayHours">
      <div class="holiday__header">
        <div>
          {{ $t('holiday_hours.holiday') + " " + (index + 1) }}
        </div>
        <div class="icon-container" @click="remove(index)">
          <svgicon src="icon/delete.svg" :height="16" :width="14"></svgicon>
        </div>
      </div>
      <div class="holiday__select">
        <label :for="`dateSelection_${index}`">{{ $t("date") }}</label>
        <datetime
            :id="`dateSelection_${index}`"
            type="date"
            value-zone="local"
            v-model="holiday.date"
            :min-datetime="today"
            input-style="width: 100%"
            :input-id="`dateSelectionInput_${index}`"
        />
      </div>
      <div class="holiday__hours">
        <DayTimeRange class="hours__range" :key="`holiday_hours_${index}`" :day="holiday"
                      dayName="holiday_hours.hours" noHoursAsClosed/>
      </div>
    </div>
    <div class="holiday-hours__add" @click="addNewHoliday">
      <div class="icon-container">
        <svgicon src="icon/add-circle.svg" :height="16" :width="16"></svgicon>
      </div>
      {{ $t('holiday_hours.add_holiday') }}
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DayTimeRange from "@/components/tools/DayTimeRange";

export default {
  name: "HolidayHours",

  components: { DayTimeRange },

  props: {
    holidayHours: {
      type: Array, /* listOf( {date: string, hours: listOf({from: string, to: string}) } ) */
      required: true
    },
  },

  data() {
    return {
      today: moment().toISOString()
    }
  },

  methods: {
    addNewHoliday() {
      let newHoliday = { date: null, hours: [] };
      this.holidayHours.push(newHoliday);
    },
    remove(index) {
      this.holidayHours.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.holiday-hours {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 20px;

  .holiday-hours__holiday {
    display: flex;
    flex-direction: column;
    max-width: calc(50% - 10px);
    min-width: calc(50% - 10px);
    box-shadow: 0px 1px 2px #0000001F;
    border-radius: 8px;
    flex-grow: 1;
    flex-basis: 0;
    padding: 12px;

    .holiday__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--primary-color);
      font-weight: bold;
    }
    .holiday__select {
      padding-bottom: 5px;
      padding-right: 10px;
    }
    .icon-container {
      align-self: flex-end;
      fill: var(--primary-color);
      cursor: pointer;
    }
  }
  .holiday__hours .hours__range.range{
    box-shadow: none ;
    border-radius: 0;
    padding: 0;
  }
  .holiday-hours__add {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #E6E6E6;
    border-radius: 8px;
    flex-grow: 1;
    flex-basis: 0;
    max-width: calc(50% - 10px);
    min-height: 209px;
    cursor: pointer;
    color: var(--primary-color);
    fill: var(--primary-color);

    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }
  }
  .icon-container {
    padding: 16px;
  }

  @media screen and (max-width: 600px) {
    .holiday-hours__holiday {
      max-width: 100%;
      min-width: 100%;
      //flex-wrap: wrap;
      .holiday__select, .holiday__hours {
        flex-basis: 80%;
      }
      .holiday__select {
        order: 1;
      }
      .holiday__hours {
        order: 3;
        padding-right: 0;
        padding-top: 10px;
      }
      .icon-container {
        order: 2;
        justify-self: flex-end;
      }
    }
    .holiday-hours__add {
      max-width: 100%;
      min-width: 100%;
      min-height: 70px;
    }
  }
}
</style>